<template>
	<div>
		<v-card-title class="card-header fixed-card-title2">
			{{ $t('addMedicalTeam') }}
			<v-spacer />
			<v-icon color="white" @click="closeDrawer">mdi-window-close</v-icon>
		</v-card-title>
		<v-card-text color="primary" class="mt-3">
			<v-form>
				<v-row dense>
					<v-col cols="12" lg="12" md="12" sm="12">
						<v-text-field
							v-model="searchPatient"
							append-icon="mdi-magnify"
							:label="$t('search-Patient')"
							single-line
							hide-details
							class="my-1"
							outlined
							dense></v-text-field>
						<v-data-table
							:loading="loadingPatients"
							dense
							fixed-header
							:items="filteredPatients"
							item-key="item.id"
							:no-data-text="$t('no-data-available')"
							:loading-text="$t('loading')"
							:search="searchPatient"
							height="35vh"
							:headers="patientHeadr"
							v-model="selectedRows"
							style="width: 500px"
							:items-per-page="-1"
							hide-default-footer
							class="elevation-1"
							:footer-props="getDataTableFooterProps('medicalTeamAddTable')">
							<template v-slot:item="{ item }">
								<tr
									:style="selectedRows.indexOf(item) > -1 ? 'color: white' : ''"
									:class="selectedRows.indexOf(item) > -1 ? 'primary' : ''"
									class="pointer"
									@click="rowClicked(item)">
									<td style="text-align: left">{{ item.firstName }} {{ item.lastName }}</td>
									<td style="text-align: left">{{ item.email }}</td>
								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" lg="12" md="12" sm="12">
						<v-text-field
							v-model="search"
							append-icon="mdi-magnify"
							:label="$t('search-medical-team')"
							single-line
							class="my-1"
							hide-details
							outlined
							dense></v-text-field>

						<v-data-table
							:key="tableKey"
							outlined
							dense
							v-model="selectedMedicalStaff"
							:items="staffData"
							:no-data-text="$t('no-data-available')"
							:loading-text="$t('loading')"
							fixed-header
							height="35vh"
							:headers="staffHeader"
							:loading="loading"
							class="elevation-1"
							show-select
							hide-default-footer
							:items-per-page="-1"
							:search="search">
							<template v-slot:[`item.primaryDoctorSwitch`]="{ item }">
								<td style="display: flex; justify-content: center; align-items: center">
									<v-switch
										dense
										v-if="item.roleId === 3"
										:input-value="primaryDoctorSelected === item.id"
										@click="handlePrimaryDoctorSwitch(item.id)"
										class="ma-0"
										color="primary"
										hide-details></v-switch>
								</td>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions class="fixed-card-actions">
			<v-row dense class="pa-0">
				<v-col cols="6">
					<v-btn @click="closeDrawer" elevation="0" class="cancel-button-style capitalize-text">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6">
					<v-btn
						class="save-button-style mx-1"
						:loading="loading"
						:disabled="loading || checkValidity"
						@click="
							loading = false;
							createMedicalTeam().then(() => {
								loading = true;
							});
						">
						<span>{{ $t('save') }}</span>
					</v-btn>
				</v-col>
			</v-row>
		</v-card-actions>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { doctorBlack, nurseBlack } from '@/assets';
import { showSuccessAlert, showErrorAlert, getDataTableFooterProps } from '@/utils/utilities';
export default {
	props: ['dialog', 'data', 'deniedPatients'],
	data () {
		return {
			selectedMedicalStaff: [],
			tableKey: 0,
			loader: null,
			loading: true,
			loadingPatients: false,
			search: '',
			medicalTemaName: null,
			selectedStaff: [],
			relatedPatients: [],
			staff: [],
			doctors: [],
			starterArray: [],
			selectedPatient: undefined,
			medicalTeamTitle: '',
			doctor_black: doctorBlack,
			nurse_black: nurseBlack,
			searchPatient: '',
			searchMedicalTeam: null,
			primaryDoctor: null,
			patients: [],
			primaryDoctorSelected: null,
			staffSelected: [],
			selectedRows: [],
			patientHeadr: [
				{
					text: this.$t('name'),
					align: 'start',
					class: 'table-header pl-3',
					value: 'firstName',
				},
				{
					text: this.$t('email-address'),
					align: 'start',
					class: 'table-header pl-3',
					value: 'email',
				},
			],
			staffHeader: [
				{
					text: this.$t('name'),
					align: 'left',
					class: 'table-header px-4',
					value: 'fullName',
				},
				{
					text: this.$t('role'),
					align: 'left',
					class: 'table-header px-4',
					value: 'role',
				},
				{
					text: this.$t('primary-doctor'),
					class: 'table-header px-0',
					value: 'primaryDoctorSwitch',
				},
			],
		};
	},
	computed: {
		...mapState({
			detailsDrawer: (state) => state.detailsDrawer,
			userDetails: (state) => state.authentication.userData,
			userData: (state) => state.authentication.userData,
			relatedMedicalStaff: (state) => state.hospitals.users,
		}),
		...mapGetters({
			getPatients: 'hospitals/getPatients',
			roleName: 'authentication/getRole',
			getUser: 'authentication/getUser',
			pageHeight: 'pageHeight',
		}),
		filteredPatients () {
			return this.getPatients?.filter((patient) => {
				return !patient.hasMedicalTeam && patient.status === 1;
			});
		},
		staffData () {
			return this.staff.filter((s) => {
				return s.id !== this.primaryDoctor && s.status === 1;
			});
		},
		checkValidity () {
			if (!this.medicalTemaName) {
				return true;
			}
			if (!this.selectedMedicalStaff || this.selectedMedicalStaff.length === 0) {
				return true;
			}
			if (!this.primaryDoctorSelected) {
				return true;
			}
			return false;
		},
	},
	watch: {
		selectedMedicalStaff (val) {
			const selectedStaffIds = val.map((staff) => staff.id);
			if (this.primaryDoctorSelected && !selectedStaffIds.includes(this.primaryDoctorSelected)) {
				this.primaryDoctorSelected = null;
			}
		},
		detailsDrawer (val) {
			if (val) {
				this.renderPatients();
				this.staffSelected = [];
			}
		},
		search (val) {},
	},
	async mounted () {
		this.staffSelected = [];
		await this.renderPatients();
		if (this.relatedMedicalStaff == null) {
			await this.getRelatedMedicalStaff();
		} else {
			if (this.relatedMedicalStaff !== null) {
				this.staff = this.relatedMedicalStaff
					.filter((users) => users.roleId === 3 || users.roleId === 4)
					.map(
						(users) =>
							(users = {
								id: users.id,
								fullName: users.firstName + ' ' + users.lastName,
								role: users.roleData?.roleNameForDisplay,
								roleId: users.roleId,
								status: users.status,
							}),
					);
				this.doctors = this.staff.filter((s) => {
					return s.roleId === 3;
				});
			} else this.staff = [];
		}
		this.loading = false;
	},
	methods: {
		getDataTableFooterProps,
		async closeDrawer () {
			this.$store.commit('SET_DETAILS_DRAWER', false);
			this.staffSelected = [];
			this.primaryDoctorSelected = null;
			this.selectedMedicalStaff = [];
			this.selectedRows = [];
		},
		async renderPatients () {
			this.loadingPatients = true;
			await this.$store
				.dispatch('hospitals/getRelatedPatients', localStorage.getItem('selectedHospitalAssignedId'))
				.then(() => {
					this.loadingPatients = false;
				});
		},
		rowClicked (row) {
			this.toggleSelection(row);
			this.medicalTemaName = `${row.firstName} ${row.lastName}`;
			if (this.selectedRows.length > 1) {
				this.selectedRows.shift();
			}
		},
		toggleSelection (keyID) {
			if (this.selectedRows.includes(keyID)) {
				this.selectedRows = this.selectedRows.filter((selectedKeyID) => selectedKeyID !== keyID);
			} else {
				this.selectedRows = [keyID];
			}
		},
		async getRelatedMedicalStaff () {
			try {
				await this.$store.dispatch(
					'hospitals/getRelatedMedicalStaffForHospital',
					this.userDetails.hospitalAssignedData.id,
				);
				if (this.relatedMedicalStaff) {
					this.staff = this.relatedMedicalStaff
						.filter((user) => user.roleId === 3 || user.roleId === 4)
						.map((user) => ({
							id: user.id,
							fullName: `${user.firstName} ${user.lastName}`,
							role: user.roleData?.roleNameForDisplay,
							roleId: user.roleId,
							status: user.status,
						}));
					this.doctors = this.staff.filter((s) => s.roleId === 3);
					this.relatedMedicalStaff.forEach((item) => {
						if (item.medicalTeamsData && item.medicalTeamsData.length > 0) {
							item.forAdd = item.medicalTeamsData.some((team) => team.membersList && team.membersList.length > 0);
							if (item.forAdd) {
								this.patients.push(item);
							}
						} else {
							item.forAdd = false;
							this.patients.push(item);
						}
					});
				} else {
					this.staff = [];
				}
			} catch (error) {
				this.staff = [];
			}
		},
		async createMedicalTeam () {
			const body = {
				hospitalId: localStorage.getItem('selectedHospitalAssignedId'),
				patientId: this.selectedRows[0].id,
				primaryDoctorId: this.primaryDoctorSelected,
				medicalTeamTitle: this.medicalTemaName + ' Team',
				medicalTeamDescription: this.medicalTemaName + ' Team',
				status: 1,
			};
			try {
				const res = await this.$store.dispatch('medicalteam/createMedicalTeam', body);
				if (res) {
					showSuccessAlert(this.$t('success'));
					await this.assignMemberToMedicalTeam(res.id);
				} else {
					showErrorAlert(this.$t('failed!'));
				}
			} catch (error) {
				showErrorAlert(this.$t('failed!'));
			}
			await this.closeDrawer();
		},
		async assignMemberToMedicalTeam (medicalTeamId) {
			const results = [];
			for (const staff of this.selectedMedicalStaff) {
				const bodyAssign = {
					medicalTeamId: medicalTeamId,
					memberUserIdList: [staff.id],
				};
				try {
					const res = await this.$store.dispatch('medicalteam/assignMultipleMembersToMedicalTeam', bodyAssign);
					if (res) {
						results.push(res);
					}
				} catch (error) {
					showErrorAlert(this.$t('failed!'));
				}
			}
			try {
				await this.$store.dispatch(
					'hospitals/getRelatedMedicalStaffForHospital',
					this.userData.hospitalAssignedData.id,
				);
				this.loading = false;
				this.staffSelected = [];
				await this.$store.dispatch('medicalteam/getMedicalTeams', this.getUser.hospitalAssignedData.id);
				this.$emit('false');
			} catch (error) {
				showErrorAlert(this.$t('failed!'));
			}
		},
		handlePrimaryDoctorSwitch (staffId) {
			if (this.primaryDoctorSelected === staffId) {
				this.primaryDoctorSelected = null;
			} else {
				this.primaryDoctorSelected = staffId;
			}

			const isPrimaryDoctorSelected = this.selectedMedicalStaff.some((staff) => staff.id === staffId);
			if (this.primaryDoctorSelected && !isPrimaryDoctorSelected) {
				const primaryDoctor = this.staff.find((s) => s.id === this.primaryDoctorSelected);
				if (primaryDoctor) {
					this.selectedMedicalStaff.push(primaryDoctor);
				}
			}
		},
	},
};
</script>
